import { createSlice } from "@reduxjs/toolkit";

export const sidebardrawerSlice = createSlice({
  name: "sidebardrawer",
  initialState: {
    isOpen: false,
    content: null,
    onClose: () => {},
  },
  reducers: {
    openSidebar: (state, { payload }) => {
      state.isOpen = true;
      state.onClose = payload?.onClose;
      state.content = payload?.content;
    },
    closeSidebar: (state) => {
      state.isOpen = false;
      state.onClose = () => {};
      // state.content = null;
    },
  },
});

export const { openSidebar, closeSidebar } = sidebardrawerSlice.actions;

export default sidebardrawerSlice.reducer;
